import React from 'react';

const RespondArrow = ({ height = 32, width = 32, color = '#494949', ...props }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>respond arrow</title>
    <g fill="#494949">
      <path d="M31,15L17,2v8C6.503,10.35,1,15.544,1,26.383V30c3.938-6.688,5.812-9,16-9v8L31,15z" fill={color} />
    </g>
  </svg>
);

export default RespondArrow;
